import { FieldValues } from 'react-hook-form'

import { ButtonDropdownOption } from '~/components/component-library'
import { createTransactionHandlers } from '~/components/smart-accounts/transactions/createTransactionHandlers'

type BaseEventProperties = {
  eventType: string
}

type ActionButton = {
  text: string
  onClick: () => void
  isDisabled: boolean
  eventName?: string
  eventProperties?: BaseEventProperties
  fullWidth?: boolean
  dropdownOptions?: ButtonDropdownOption[]
}

type ActionButtonConfig<TFormData extends FieldValues> = {
  canExecute: boolean
  isValidForm: boolean
  isLoading: boolean
  handlers: ReturnType<typeof createTransactionHandlers<TFormData>>
  eventType: string
  isReview: boolean
  handleReview: () => void
  reviewDropdownOptions?: ButtonDropdownOption[]
}

export const createActionButtonProps = <TFormData extends FieldValues>({
  canExecute,
  isValidForm,
  handlers,
  eventType,
  isReview,
  handleReview,
  reviewDropdownOptions,
}: ActionButtonConfig<TFormData>) => {
  return !isReview
    ? {
        actionButton: {
          text: 'Review',
          onClick: handleReview,
          isDisabled: !isValidForm,
        } as ActionButton,
      }
    : canExecute
      ? {
          actionButton: {
            // consolidated "Execute" and "Submit" button text to simplify UX
            text: 'Submit',
            onClick: handlers.onExecute,
            isDisabled: !isValidForm,
            eventName: `clicked${eventType}Execute`,
            eventProperties: {
              eventType,
            },
            dropdownOptions: reviewDropdownOptions,
          } as ActionButton,
        }
      : {
          actionButton: {
            text: 'Create',
            onClick: handlers.onCreate,
            isDisabled: !isValidForm,
            eventName: `clicked${eventType}Create`,
            fullWidth: true,
            dropdownOptions: reviewDropdownOptions,
          } as ActionButton,
        }
}
